import { useColorMode, useCycleList } from "@vueuse/core";
import { watch } from "vue";

export const useTheme = () => {
  const { system, store } = useColorMode({
    selector: "html",
    attribute: "data-theme",
    initialValue: "auto",
    modes: {
      light: "any-mate-light",
      dark: "any-mate-dark",
    },
    storageKey: "theme",
  });
  watch(system, (system) => {
    if (store.value === "auto") {
      document.documentElement.setAttribute(
        "data-theme",
        system === "dark" ? "any-mate-dark" : "any-mate-light"
      );
    }
  });

  const { state, next } = useCycleList(["dark", "light", "auto"], {
    initialValue: store,
  });

  watch(state, () => (store.value = state.value as any));
  watch(store, () => (state.value = store.value as any));
  return { system, store, state, next };
};

const { system, store, state, next } = useTheme();

export { system, store, state, next };
